export default function Personas(Restangular) {
  'ngInject';

  Restangular.extendModel('personas', (persona) => {
    if (persona.type === 'user' || !persona.type) {
      return Restangular.restangularizeElement(null, persona, 'users');
    }

    return Restangular.restangularizeElement(null, persona, 'groups');
  });

  return Restangular.service('personas');
}
